// The chrome (surface, no positioning) is separate so the participants toggle
// can position itself with utilities without fighting `relative`.
export const focusedControlChrome =
  "flex shrink-0 items-center gap-0.5 rounded-lg bg-zinc-950/82 p-1 shadow-lg backdrop-blur-sm";
export const focusedControlWrap = `relative ${focusedControlChrome}`;
// Radix open triggers use the same paint/text as the stock ghost hover.
export const focusedControlOpenState =
  "data-[state=open]:bg-accent data-[state=open]:text-accent-foreground dark:data-[state=open]:bg-accent/50";
